import React, { Component, Fragment } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { Modal, ModalHeader, ModalFooter, ModalBody, Button, Input, Label, FormGroup, Row, Col } from 'reactstrap';
import InfoWithTooltip from '../InfoWithTooltip';

import SSNField from '../forms/fields/socialSecurityNumber';
import PhoneField from '../forms/fields/phone';
import Checkbox from '../forms/fields/checkbox';
import { validateSocialSecurityNumber } from '../../views/patients/searchEnterprise';
import { API_ENDPOINT } from '../../constants';
import { defaultError, isStringAValidNumber } from '../TwoFactorAuthModal';
import InlineSVG from 'react-inlinesvg';
// import QRCode from "react-qr-code";
import Isvg from "react-inlinesvg";

import infoIcon from '../../assets/svg/link-new-tab.svg';
import trashIcon from '../../assets/svg/garbage.svg';
import uploadIcon from '../../assets/svg/upload.svg';
import NetId from '../../assets/images/netid.png';
import BankId from '../../assets/images/bankid.png';
import MitID from '../../assets/images/mitid.png';
import ArrowBack from '../../assets/svg/arrow-back.svg'

import axios from 'axios';
import { v4 as uuid } from 'uuid';
import DateOfBirth from '../forms/fields/dateOfBirth';
import CustomSelectWithSearch from '../forms/fields/customSelectWithSearch';
import ChatForms from '../../views/forms/chatForms';
import PreviewAnsweredChatForm from '../../views/forms/previewAnsweredChatForm';
import { generateHtml } from '../../views/forms/helper/helperFunctions';
import GenderV2Field from '../../form-v2/custom-fields/genderV2.field';
// import bankIdIcon from '../../assets/images/icon-bankid2.png';

const allowedFileTypes = ['image/jpeg', 'image/png', 'image/webp', 'text/plain', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/xml', 'application/rtf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'video/mp4', 'application/json', 'text/csv', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf'];

const allowedFileTypeExtensions = ['jpg', 'jpeg', 'png', 'webp', 'txt', 'xls', 'xlsx', 'xml', 'rtf', 'ppt', 'pptx', 'mp4', 'json', 'csv', 'doc', 'docx', 'pdf'];

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

/**
 * @typedef {Object} Props
 * @property {Boolean} isOpen - asdf
 * @property {Boolean} hasBankId - asdf
 * @property {String} clinicGroupId - id from clinic group
 * @property {Function} closeModal - function to close the modal
 * @property {String} lang - language
 */

/**
 * @class
 * @augments {Component<Props, State>}
 */
export class EconnectExternalCasesModal extends Component {
    /**
     * 
     * @param {Props} props 
     */
    constructor(props) {
        super(props)

        this.state = {
            num: 0,
            loading: false,
            error: null,

            step: 1,

            bankId: '',
            bankIdError: null,
            sign: false,
            submitting: false,

            patient: {
                type: ['denmark', 'sweden'].includes(props?.country) ? null : 'external',
                id: null,
                ssn: '',
                name: '',
                gender: '',
                phone: '',
                email: '',
                dateOfBirth: '',
            },
            sender: {
                type: 'external',
                id: null,
                departmentId: null,
                name: '',
                city: '',
                street: '',
                zip: '',
                phone: '',
                email: '',
                user: '',
            },
            subject: '',
            anamnesis: '',
            status: '',
            attachments: [],
            patientConsent: false,

            pdfGenerated: false,
            qrCodeTimeExpiration: 1
        }
    }

    onMessage = (e) => {
        if (e?.data?.includes?.('signed')) {
            let id;
            if (e?.data?.includes?.('=')) {
                id = e.data.split('=')?.[1] ?? null;
                this.submitCase(id, true, false);
            }
        }

        if (e?.data?.includes?.('sign_netid')) {
            let id;
            if (e?.data?.includes?.('=')) {
                id = e.data.split('=')?.[1] ?? null;
                this.submitCase(id, false, true);
            }
        }
    }

    getClinicGroupSettings = () => {
        try {
            this.setState({ clinicGroupSettings: null }, async () => {
                if (!this.props?.clinicGroupId) return;
                const response = await fetch(API_ENDPOINT + '/data/clinic-group-settings/' + this.props.clinicGroupId);
                if (!response || !response.ok) return;
                const result = await response.json();
                if (!result || result.error || !result.clinicGroupSettings) return;
                this.setState({ clinicGroupSettings: result.clinicGroupSettings });
            })
        } catch (err) { }
    }

    componentDidMount() {
        const _uuid = uuid();
        const uploadHeader = 'curoflow-econnect';
        const uploadToken = this.generateRandomToken();
        this.setState({ uuid: _uuid, uploadHeader, uploadToken });

        this.getClinicGroupSettings();

        window?.addEventListener?.('message', this.onMessage);

        if (this.props.hasBankId)
            this.interval = setInterval(() => {
                if (this.state.qrCodeExpired) {
                    return
                }
                this.checkBankIdSign()
                const imageElement = document.getElementById('qr-image');
                if (imageElement && this.state.qrCodeChanged) {
                    this.setState({
                        qrCodeChanged: false
                    }, () => {
                        this.qrCodeChanged()
                    })
                }

            }, 2000);

        this.getEConnectQuestionaries()
        window.addEventListener("keydown", this.onKeyDown, { capture: true }); // capture gets it early

    }

    onKeyDown = (e) => {
        // ignore when typing in inputs/editors
        // const tgt = e.target;
        // if (tgt && (tgt.closest('input, textarea, [contenteditable="true"]'))) return;

        // detect Space
        if (e.code === "Space" || e.key === " ") {
            if (e.repeat) return;
            if (this.componentUnmounted) return;
            if (this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30) {


                if (e.code === 'Space' || e.key === ' ' || e.keyCode === 32) {
                    e.preventDefault();

                    this.setState({
                        qrCodeExpired: false,
                        qrCodeTimeExpiration: 1
                    }, () => {
                        clearInterval(this.qrCodeInterval);
                        this.handler('sign');
                        if (this.qrCodeButton) {
                            this.qrCodeButton.focus({ preventScroll: true })
                        }

                    })
                }

            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.mitidVerify && this.state.mitidVerify !== prevState.mitidVerify) {

            if (this.state.mitidVerify.includes('sessionStatus=Finished')) {
                this.signWithMitID(this.state.mitidVerify.split('sessionId=')[1]?.split('&')[0]);
            } else {
                this.setState({
                    mitIDRedirectUrl: null,
                    mitidVerify: null,
                    error: 'Something went wrong, please try again'.translate(this.props.lang)
                })
            }

        } else if (!this.state.mitIDRedirectUrl && this.state.mitIDRedirectUrl !== prevState.mitIDRedirectUrl && !this.state.mitidVerify) {
            this.signWithMitID(null);
        }

        if (prevProps?.clinicGroupId !== this.props?.clinicGroupId) this.getClinicGroupSettings();
    }
    signWithMitID = (session) => {
        fetch(API_ENDPOINT + '/users/mitID/check', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: session,
                sign: true,
                key: this.state.mitIDKey ? this.state.mitIDKey : null,
                group: this.props.clinicGroupId ? this.props.clinicGroupId : '',
                alias: this.props.alias ? this.props.alias : localStorage.getItem('groupAlias')
            })
        }).then(res => res.json()).then((result) => {

            if (result && result.status && result.status === 'Finished') {
                this.submitCase(this.state.mitIDKey, false, false, true)
            }


        })
    }
    generateSections = () => {
        let sections = {};
        if (this.state.referral) {
            let items = [{ type: 0 }, ...this.state.referral.items];
            let lastSectionId = -1;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type == 0) {
                    lastSectionId++;
                    sections[lastSectionId] = {
                        name: items[i].name,
                        displayOnReferral: false,
                        questions: [],
                        conditions: items[i].conditions ? items[i].conditions : [],
                        displayOnReferral: items[i].displayOnReferral,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        required: items[i].required,

                    }
                }
                if (lastSectionId != -1 && items[i].type != 0) {


                    let wikiLinks = [];

                    items[i].wikiLinks = wikiLinks;


                    if (items[i].type == 1) {
                        let displayOnReferral = false;
                        if (items[i].answers) {
                            for (let j = 0; j < items[i].answers.length; j++) {
                                if (items[i].answers[j].text) {
                                    displayOnReferral = true;
                                }
                            }
                        }

                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            answers: items[i].answers,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            displayOnReferral: displayOnReferral,
                            wikiLinks: items[i].wikiLinks,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        });

                    } else if (items[i].type == 2) {
                        let displayOnReferral = false;
                        if (items[i].answers) {
                            for (let j = 0; j < items[i].answers.length; j++) {

                                if (items[i].answers[j].text) {
                                    displayOnReferral = true;
                                }
                            }
                        }
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            answers: items[i].answers,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            answerPrefix: items[i].answerPrefix,
                            userInput: items[i].userInput,
                            displayOnReferral: displayOnReferral || items[i].answerPrefix ? true : false,
                            wikiLinks: items[i].wikiLinks,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,

                        })
                    } else if (items[i].type == 3) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            answerPrefix: items[i].answerPrefix,
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 4) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            text: items[i].text,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 5) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 6) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 7) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 8) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 9) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 10) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            userInput: items[i].userInput,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })
                    } else if (items[i].type == 12) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 13) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                        })

                    } else if (items[i].type == 15) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            text: items[i].text,
                            userInput: items[i].userInput,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                            hideTitle: items[i].hideTitle ? true : false,
                            titleFontStyle: items[i].titleFontStyle,
                            titleFontSize: items[i].titleFontSize,
                            titleFontWeight: items[i].titleFontWeight,
                        })

                    } else if (items[i].type == 16) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                            blocks: items[i].blocks,
                        })

                    } else if (items[i].type == 17) {
                        sections[lastSectionId].questions.push({
                            id: items[i].id,
                            type: items[i].type,
                            name: items[i].name,
                            conditions: items[i].conditions ? items[i].conditions : [],
                            wikiLinks: items[i].wikiLinks,
                            displayOnReferral: true,
                            fontStyle: items[i].fontStyle,
                            fontSize: items[i].fontSize,
                            fontWeight: items[i].fontWeight,
                            required: items[i].required,
                            blocks: items[i].blocks,

                        })

                    }
                }
            }
            return Object.values(sections);
        }

    }
    checkBankIdSign = () => {
        fetch(API_ENDPOINT + '/users/bankid/v5/check/sign/e-connect', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ key: this.state.key, group: this.props.clinicGroupId ? this.props.clinicGroupId : '' })
        }).then(res => res.json()).then((result) => {
            if (result && result.pending) {
                this.setState({
                    qrCodePendingSign: true,
                    loading: true
                }, () => {
                    if (this.qrCodeInterval) {
                        clearInterval(this.qrCodeInterval)
                    }

                })
            }
            if (result && result.failed && !this.state.qrCodeTryAgain) {
                this.setState({
                    qrCodeExpired: true,
                }, () => {
                    if (this.qrCodeInterval) {
                        clearInterval(this.qrCodeInterval)
                    }
                })
            }
            if (result && result.status && result.status === 'Finished') {
                // this.props.toggle(this.props.isOpen && this.props.isOpen.key)
                this.submitCase(this.state.key, true, false)
                clearInterval(this.interval)
                clearInterval(this.qrCodeInterval)
            }
        })
    }

    componentWillUnmount() {
        this.componentUnmounted = true;
        window?.removeEventListener?.('message', this.onMessage);
        clearInterval(this.timer1);

        if (this.interval) {
            clearInterval(this.interval)
        }
        if (this.qrCodeInterval) {
            clearInterval(this.qrCodeInterval)
        }

        window.removeEventListener("keydown", this.onKeyDown);
    }

    generateRandomToken = () => {
        const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        const letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
        const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        const generateRandomNumber = (max, min = 0) => Math.floor(Math.random() * (max - min) + min);
        const possibilities = [...numbers, ...letters, ...LETTERS];

        let token = '';

        for (let i = 0; i < 5; i++) {
            let code = '';
            for (let j = 0; j < 5; j++) {
                if (i === 0 && j === 0) code += 'r';
                else if (i === 1 && j === 1) code += 'a';
                else if (i === 2 && j === 2) code += 'd';
                else if (i === 3 && j === 3) code += 'a';
                else if (i === 4 && j === 4) code += 'n';
                else code += possibilities[generateRandomNumber(possibilities.length)];
            }

            if (i === 0) token = code;
            else token += `-${code}`
        }

        return token;
    }

    generateHtmlPreview = () => {
        let answers = this.state.questionaryAnswers;

        if (!this.state.htmlAnswers || (this.state.htmlAnswers && JSON.stringify(answers) !== JSON.stringify(this.state.htmlAnswers))) {
            let html = generateHtml({
                sections: this.generateSections(),
                answers: answers,
                question18Finished: [],
                intelligentReferral: this.state.referral?.intelligentReferral
            }, this.props.lang, null, true, false, true);
            // console.log('html: ', html);

            this.setState({ html, htmlAnswers: JSON.parse(JSON.stringify(answers)) })
        }

    }

    submitCase = (id, signedWithBankId = false, signedWithNetId = false, signedWithMitId = false) => {
        this.setState({ loading: true, submitting: true, sign: false }, async () => {
            const form = {
                id,
                signedWithBankId,
                signedWithNetId,
                signedWithMitId,
                patient: this.state.patient,
                sender: this.state.sender,
                receiverId: this.props.clinicGroupId,
                subject: this.state.subject,
                anamnesis: this.state.anamnesis,
                status: this.state.status,
                eConnectForm: this.state.referral ? {
                    questionaryName: this.state.referral?.name,
                    questionaryId: this.state.referral?._id,
                    sections: this.generateSections(),
                    answers: this.state.questionaryAnswers,
                    items: this.state.referral.items,
                    description: this.state.referral.description,
                    intelligentReferral: this.state.referral.intelligentReferral,
                    html: this.state.html,
                } : null,
                attachments: this.state.attachments,
                uuid: this.state.uuid,
                patientConsent: this.state.patientConsent
            };

            const response = await fetch(API_ENDPOINT + '/e-connect/ext/cases', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'x-cf-upload-token': this.state.uploadToken,
                    'x-cf-upload-header': this.state.uploadHeader
                },
                body: JSON.stringify({ form })
            });
            const result = await response?.json?.();

            if (!result || result.error || !result.uuid) return this.setState({
                loading: false,
                submitting: false,
                error: result.error || defaultError,
            });

            this.numOfTries = 0;
            this.checkProgress(result.uuid);
        });
    }

    getPdf = (id) => {
        if (this.state.pdfGenerated || !id) return;
        this.setState({ loading: true }, async () => {
            const newState = {
                loading: false,
            }
            const response = await fetch(API_ENDPOINT + `/e-connect/cases/pdf/${id}?lang=${this.props.lang || 'en'}&groupId=${this.props.clinicGroupId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage?.getItem?.('authToken')}`,
                    'x-cf-upload-token': this.state.uploadToken,
                    'x-cf-upload-header': this.state.uploadHeader
                }
            });
            if (!response) {
                newState.error = defaultError;
                return this.setState(newState);
            }
            const result = await response.json();
            if (!result || !result.url || result.error) {
                newState.error = result.error || defaultError;
                return this.setState(newState);
            }

            this.setState(newState, () => {
                window?.open?.(API_ENDPOINT + result.url, '_blank');
                this.setState({ pdfGenerated: true });
            });
        })
    }

    checkProgress = (uuid) => {
        if (!uuid) return;
        const fetcher = async (uuid) => {
            const response = await fetch(API_ENDPOINT + `/e-connect/cases/check/${uuid}`, {
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage?.getItem?.('authToken')}`
                }
            });
            if (!response || !response.ok) return null;
            const result = await response.json();
            if (!result || !result.id) return null;
            return result.id;
        }
        this.timer1 = setInterval(async () => {
            if (this.numOfTries >= 5) {
                clearInterval(this.timer1);
                this.timer1 = null;
                this.setState({ loading: false, submitting: false, error: defaultError });
                return;
            }
            let newNum = (this.numOfTries || 0) + 1;
            this.numOfTries = newNum;
            const id = await fetcher(uuid);
            if (id) {
                clearInterval(this.timer1);
                this.timer1 = null;
                this.setState({ loading: false, submitting: false, step: 5 })
            }
        }, 1500);
    }

    uploadFiles = (files) => {
        if (!files) return;
        try {
            files = Array.from(files);
            if (files && Array.isArray(files) && files.length > 0) {
                this.setState({ _uploading: true, _dragging: false }, async () => {
                    let attachments = [];
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        if (!file || !file.type || !file.name) continue;
                        if (!allowedFileTypes.includes(file.type)) continue;
                        const obj = {
                            type: (file.type?.startsWith?.('video') ? (
                                'video'
                            ) : file.type?.startsWith?.('image') ? (
                                'image'
                            ) : 'file'),
                            name: file.name
                        };

                        // 512 MB for video, 50 MB for other files (exception for 50MB requested by product team)
                        let limit = obj.type === 'video' ? 524288 : 51200;
                        let size = Math.round((file.size / 1024));
                        if (size > limit) continue;

                        const formData = new FormData();
                        formData.append('file', file);
                        formData.append('group', this.props.clinicGroupId);
                        formData.append('fileType', 'eConnect');

                        try {
                            const response = await axios.post(API_ENDPOINT + '/data/upload-document', formData, {
                                headers: {
                                    Accept: 'application/json',
                                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                    'x-cf-upload-token': this.state.uploadToken,
                                    'x-cf-upload-header': this.state.uploadHeader
                                }
                            });
                            if (response && response.status && response.status == 200 && response.data) {
                                obj.url = response.data;
                                attachments.push(obj);
                            }
                        } catch (err) {
                            console.log('upload err: ', err);
                            continue;
                        }
                    };

                    this.setState(prev => ({
                        ...prev,
                        _uploading: false,
                        attachments: [...(prev?.attachments || []), ...attachments]
                    }));

                    if (attachments && attachments.length > 0) {
                        fetch(API_ENDPOINT + '/e-connect/uploads', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                'x-cf-upload-token': this.state.uploadToken,
                                'x-cf-upload-header': this.state.uploadHeader
                            },
                            body: JSON.stringify({
                                attachments,
                                uuid: this.state.uuid
                            })
                        });
                    }
                });
            }
        } catch (err) {
            console.log('upload files err: ', err);
        }
    }

    onChangeAttachment = (file) => {
        if (!file) return;
        if (file && file.delete) {
            const url = file.url;
            if (!url) return;
            const attachments = this.state.attachments?.filter?.(item => item.url !== url);
            this.setState({ attachments })
            return;
        }
        this.setState(prev => ({ attachments: [...(prev?.attachments || []), file] }));
    }
    qrCodeChanged = () => {
        if (this.qrCodeInterval) {
            clearInterval(this.qrCodeInterval)
        }

        this.setState({
            qrCodePendingSign: false,
            qrCodeExpired: false
        })
        const qrCodeLink = this.state.qrCodeLink;
        const imageElement = document.getElementById('qr-image');
        let t = 0;
        // console.log(imageElement);
        console.log(this.state);

        this.qrCodeInterval = setInterval(() => {
            // QR code doesn't work after repeating 14 times so that is the limit for bankid v5 for now
            if (t === 14) {
                clearInterval(this.qrCodeInterval);
                this.handler('sign')
                t = 0;
            }
            if (imageElement)
                imageElement.setAttribute('src', qrCodeLink + '&t=' + t);
            t++;
            this.setState({
                qrCodeTimeExpiration: this.state.qrCodeTimeExpiration + 1
            }, () => {
                if (this.state.qrCodeTimeExpiration === 150) {
                    clearInterval(this.qrCodeInterval);
                    this.setState({
                        qrCodeExpired: true
                    })
                }
            })
        }, 2000)
    }
    startBankIDSign = async () => {
        const response = await fetch(API_ENDPOINT + '/users/bankid/v5/sign/e-connect', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'x-cf-upload-token': this.state.uploadToken,
                'x-cf-upload-header': this.state.uploadHeader
            },
            body: JSON.stringify({
                // ssn: this.state.bankId,
                clinicGroupId: this.props.clinicGroupId
            })
        });

        if (!response || !response.ok) return this.setState({
            loading: false,
            bankIdError: true,
        });

        const result = await response.json();
        if (!result || !result.redirect_url) return this.setState({
            loading: false,
            bankIdError: true,
        });

        this.setState({ redirect_url: result.redirect_url, qrCodeLink: result.qrCodeLink, key: result.key, loading: false }, () => {
            this.setState({ sign: true, submitting: false, qrCodeChanged: true, qrCodeTryAgain: false }, () => {
                // const qrCodeLink = this.state.qrCodeLink;
                // const imageElement = document.getElementById('qr-image');
                // let t = 0;
                // this.qrCodeInterval = setInterval(() => {
                //     // QR code doesn't work after repeating 14 times so that is the limit for bankid v5 for now
                //     if (t === 14) {
                //         clearInterval(this.qrCodeInterval);
                //         this.handler('sign')
                //         t = 0;
                //     }
                //     if (imageElement)
                //         imageElement.setAttribute('src', qrCodeLink + '&t=' + t);
                //     t++;
                //     this.setState({
                //         qrCodeTimeExpiration: this.state.qrCodeTimeExpiration + 1
                //     }, () => {
                //         if (this.state.qrCodeTimeExpiration === 150) {
                //             clearInterval(this.qrCodeInterval);
                //             this.setState({
                //                 qrCodeExpired: true
                //             })
                //         }
                //     })
                // }, 2000)
            })


        });
    }
    handler = (action) => {
        console.log(action);

        if (!action || action === 'no-action') return;
        if (action === 'next-step') return this.setState(prev => ({
            ...prev,
            step: +(prev?.step || 1) + 1
        }));
        // if (action === 'check-ssn') {
        //     if (this.props.uData?.socialSecurityNumber) this.setState({ bankId: this.props.uData?.socialSecurityNumber }, () => {
        //         this.setState(prev => ({
        //             ...prev,
        //             step: +(prev?.step || 1) + 1
        //         }));
        //     });

        //     else {
        //         this.setState(prev => ({
        //             ...prev,
        //             step: +(prev?.step || 1) + 1
        //         }));
        //     }

        //     return;
        // }

        if (action === 'submit') {
            this.setState({ loading: true, step: 4 }, () => {
                this.submitCase(null);
            })
        }

        if (action === 'sign') {
            // if (!this.state.bankId || this.state.bankIdError || this.state.bankId.length !== 12) return;
            this.setState({ loading: true, step: 4 }, async () => {
                if (this.props.hasMitId && this.props.skipNetId && this.props.skipBankId && !this.props.skipMitId) {
                    fetch(API_ENDPOINT + '/users/mitID/web/start', {
                        method: 'POST',
                        headers: {
                            // 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({ sign: true, group: this.props.clinicGroupId ? this.props.clinicGroupId : '', alias: this.props.alias ? this.props.alias : '' })
                    }).then(parseJSON).then(({ result, status }) => {

                        if (result && result.redirect_url) {
                            this.setState({
                                mitIDRedirectUrl: result.redirect_url,
                                mitIDKey: result.key,
                                sign: true
                            })
                        }

                    })
                    this.setState({
                        loading: false
                    })
                } else if (this.props.hasNetId && !this.props.skipNetId && this.props.skipBankId && this.props.skipMitId) {
                    fetch(API_ENDPOINT + `/users/netid/sign/start/${this.props.alias}`, {
                        method: 'GET',
                        headers: {
                            'content-type': 'application/json'
                        },
                    }).then(res => res.json()).then((result) => {
                        if (result.redirectUrl) {
                            this.setState({
                                openSiths: result.redirectUrl,
                                sign: true
                            }, () => {
                                if (this.props.alias)
                                    localStorage.setItem('groupAlias', this.props.alias)
                            })
                        }
                    })
                    this.setState({
                        loading: false
                    })
                } else if (this.props.hasBankId && !this.props.skipBankId && this.props.skipNetId && this.props.skipMitId) {
                    // const response = await fetch(API_ENDPOINT + '/users/bankid/v5/sign/e-connect', {
                    //     method: 'POST',
                    //     headers: {
                    //         'Content-Type': 'application/json',
                    //         'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    //         'x-cf-upload-token': this.state.uploadToken,
                    //         'x-cf-upload-header': this.state.uploadHeader
                    //     },
                    //     body: JSON.stringify({
                    //         // ssn: this.state.bankId,
                    //         clinicGroupId: this.props.clinicGroupId
                    //     })
                    // });

                    // if (!response || !response.ok) return this.setState({
                    //     loading: false,
                    //     bankIdError: true,
                    // });

                    // const result = await response.json();
                    // if (!result || !result.redirect_url) return this.setState({
                    //     loading: false,
                    //     bankIdError: true,
                    // });

                    // this.setState({ redirect_url: result.redirect_url, qrCodeLink: result.qrCodeLink, key: result.key, loading: false }, () => {
                    //     this.setState({ sign: true, submitting: false, qrCodeChanged: true }, () => {
                    //         // const qrCodeLink = this.state.qrCodeLink;
                    //         // const imageElement = document.getElementById('qr-image');
                    //         // let t = 0;
                    //         // this.qrCodeInterval = setInterval(() => {
                    //         //     // QR code doesn't work after repeating 14 times so that is the limit for bankid v5 for now
                    //         //     if (t === 14) {
                    //         //         clearInterval(this.qrCodeInterval);
                    //         //         this.handler('sign')
                    //         //         t = 0;
                    //         //     }
                    //         //     if (imageElement)
                    //         //         imageElement.setAttribute('src', qrCodeLink + '&t=' + t);
                    //         //     t++;
                    //         //     this.setState({
                    //         //         qrCodeTimeExpiration: this.state.qrCodeTimeExpiration + 1
                    //         //     }, () => {
                    //         //         if (this.state.qrCodeTimeExpiration === 150) {
                    //         //             clearInterval(this.qrCodeInterval);
                    //         //             this.setState({
                    //         //                 qrCodeExpired: true
                    //         //             })
                    //         //         }
                    //         //     })
                    //         // }, 2000)
                    //     })


                    // });
                    this.startBankIDSign()
                } else if (this.state.pickedLoginMethod) {
                    if (this.state.pickedLoginMethod === 'bankid') {
                        // const response = await fetch(API_ENDPOINT + '/users/bankid/v5/sign/e-connect', {
                        //     method: 'POST',
                        //     headers: {
                        //         'Content-Type': 'application/json',
                        //         'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        //         'x-cf-upload-token': this.state.uploadToken,
                        //         'x-cf-upload-header': this.state.uploadHeader
                        //     },
                        //     body: JSON.stringify({
                        //         // ssn: this.state.bankId,
                        //         clinicGroupId: this.props.clinicGroupId
                        //     })
                        // });

                        // if (!response || !response.ok) return this.setState({
                        //     loading: false,
                        //     bankIdError: true,
                        // });

                        // const result = await response.json();
                        // if (!result || !result.redirect_url) return this.setState({
                        //     loading: false,
                        //     bankIdError: true,
                        // });

                        // this.setState({ redirect_url: result.redirect_url, qrCodeLink: result.qrCodeLink, key: result.key, loading: false }, () => {
                        //     this.setState({ sign: true, submitting: false, qrCodeChanged: true }, () => {
                        //         // const qrCodeLink = this.state.qrCodeLink;
                        //         // const imageElement = document.getElementById('qr-image');
                        //         // let t = 0;
                        //         // this.qrCodeInterval = setInterval(() => {
                        //         //     // QR code doesn't work after repeating 14 times so that is the limit for bankid v5 for now
                        //         //     if (t === 14) {
                        //         //         clearInterval(this.qrCodeInterval);
                        //         //         this.handler('sign')
                        //         //         t = 0;
                        //         //     }
                        //         //     if (imageElement)
                        //         //         imageElement.setAttribute('src', qrCodeLink + '&t=' + t);
                        //         //     t++;
                        //         //     this.setState({
                        //         //         qrCodeTimeExpiration: this.state.qrCodeTimeExpiration + 1
                        //         //     }, () => {
                        //         //         if (this.state.qrCodeTimeExpiration === 150) {
                        //         //             clearInterval(this.qrCodeInterval);
                        //         //             this.setState({
                        //         //                 qrCodeExpired: true
                        //         //             })
                        //         //         }
                        //         //     })
                        //         // }, 2000)
                        //     })


                        // });
                        this.startBankIDSign()
                    } else if (this.state.pickedLoginMethod === 'netid') {
                        fetch(API_ENDPOINT + `/users/netid/sign/start/${this.props.alias}`, {
                            method: 'GET',
                            headers: {
                                'content-type': 'application/json'
                            },
                        }).then(res => res.json()).then((result) => {
                            if (result.redirectUrl) {
                                this.setState({
                                    openSiths: result.redirectUrl,
                                    sign: true
                                }, () => {
                                    if (this.props.alias)
                                        localStorage.setItem('groupAlias', this.props.alias)
                                })
                            }
                        })
                        this.setState({
                            loading: false
                        })
                    } else if (this.state.pickedLoginMethod === 'mitid') {
                        fetch(API_ENDPOINT + '/users/mitID/web/start', {
                            method: 'POST',
                            headers: {
                                // 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({ sign: true, group: this.props.clinicGroupId ? this.props.clinicGroupId : '', alias: this.props.alias ? this.props.alias : '' })
                        }).then(parseJSON).then(({ result, status }) => {

                            if (result && result.redirect_url) {
                                this.setState({
                                    mitIDRedirectUrl: result.redirect_url,
                                    mitIDKey: result.key
                                })
                            }

                        })
                        this.setState({
                            loading: false
                        })
                    }
                } else {
                    this.setState({
                        sign: true,
                        loading: false
                    })
                }

            })
        }
    }

    checkSSN = (ssn) => {
        const country = this.state.countryStateDict?.['ssn'] ?? this.props.country;

        if (!ssn || !ssn.length) return;
        const check = validateSocialSecurityNumber(ssn, null, country);
        if (check?.error || !isStringAValidNumber(ssn)) return this.setState(prev => ({
            ...prev,
            ssnError: check?.error || 'Invalid SSN',
            patient: {
                type: null,
                id: null,
                ssn: '',
                name: '',
                gender: '',
                phone: '',
                email: '',
                dateOfBirth: '',
            },
        }));


        this.setState({ loading: true }, async () => {
            const response = await fetch(API_ENDPOINT + `/e-connect/patients/${ssn}`, {
                headers: {
                    'Content-Type': 'application/json', 'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'x-cf-upload-token': this.state.uploadToken,
                    'x-cf-upload-header': this.state.uploadHeader
                }
            });
            if (!response || !response.ok) return this.setState(prev => ({
                ...prev,
                loading: false,
                patient: {
                    ssn,
                    type: 'external',
                    id: null,
                    name: '',
                    gender: '',
                    phone: '',
                    email: '',
                    dateOfBirth: '',
                }
            }));

            const result = await response.json();
            if (!result || !result.id) return this.setState(prev => ({
                ...prev,
                loading: false,
                patient: {
                    ssn,
                    type: 'external',
                    id: null,
                    name: '',
                    gender: '',
                    phone: '',
                    email: '',
                    dateOfBirth: '',
                }
            }));

            return this.setState(prev => ({
                ...prev,
                loading: false,
                patient: {
                    ssn,
                    type: 'internal',
                    id: result.id
                }
            }))
        });
    }

    getEConnectQuestionaries = () => {

        fetch(API_ENDPOINT + '/data/without-token/e-connect-forms/all/' + this.props.alias, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: 0,
            })
        }).then(res => res.json()).then((result) => {

            if (result.clinicGroup) {
                this.setState({ clinicGroup: result.clinicGroup })
            }
            if (result.referrals) {
                this.setState({ referrals: result.referrals })
            }
            if (result.total) {
                this.setState({ total: result.total })
            } else {
                this.setState({ total: 0 })
            }

        })


    }

    generatePdf = (id, callback) => {
        fetch(API_ENDPOINT + '/data/e-connect-forms/generate/pdf', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                healthCareReferral: id,
                group: this.props.clinicGroupId ? this.props.clinicGroupId : '',
                answers: this.state.questionaryAnswers,
                user: this.state.patient?.id,
                sender: this.state.sender,
                lang: this.props.lang,
                isDoctor: false
            })
        }).then(res => res.json()).then((result) => {

            if (result && result.pdf) {
                if (this.state.attachments) {
                    let attachments = this.state.attachments
                    attachments.push({ url: result.pdf, type: 'pdf', name: result.pdfName ? result.pdfName + '.pdf' : 'PDF' })
                    this.setState({ attachments }, () => {
                        callback();
                    })
                }
            }
        })

    }
    minutesLeft = (time) => {
        const timeLeft = 300 - 2 * time
        if (timeLeft > 50) {
            return Math.ceil(timeLeft / 60) + " " + 'minutes left'.translate(this.props.lang)
        }
        if (timeLeft <= 10) {
            return '10 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 20) {
            return '20 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 30) {
            return '30 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 40) {
            return '40 seconds left'.translate(this.props.lang)
        }
        if (timeLeft <= 50) {
            return '50 seconds left'.translate(this.props.lang)
        }
    }

    percentageLeft = (current, amount) => {
        // going from 100% do 0%
        return Math.floor(((amount - current) / amount) * 100)
    }

    generateDropDownText = () => {
        return <div style={{ width: 300 }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                    this.setState({
                        showHelpDropDown: !this.state.showHelpDropDown,
                        showReaderDropDown: false
                    })
                }}>
                    <h5>{"Help with scanning the QR code".translate(this.props.lang)}</h5>
                    <div style={{ transform: `rotate(90deg)`, fontSize: 24 }}>{">"}</div>
                </div>
                {
                    this.state.showHelpDropDown ?
                        <div style={{ textAlign: 'left' }}>
                            <ol>
                                <li>{'Open the BankID app'.translate(this.props.lang)}</li>
                                <li>{"Press the button 'Scan QR code'".translate(this.props.lang)}</li>
                                <li>{"Aim the phone's camera towards the QR code".translate(this.props.lang)}</li>
                                <li>{'Follow the instructions in the app'.translate(this.props.lang)}</li>
                            </ol>
                            <p style={{ padding: 10 }}>
                                {"The QR code is shown for 5 minutes before the identification is cancelled for security reasons. You can try again if that happens.".translate(this.props.lang)}
                            </p>
                            <p style={{ padding: 10 }}>
                                {"Make sure the entire QR code fits on the screen, otherwise it can't be scanned.".translate(this.props.lang)}

                            </p>
                        </div>
                        :
                        null
                }
            </div>
            <hr />
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                    this.setState({
                        showReaderDropDown: !this.state.showReaderDropDown,
                        showHelpDropDown: false
                    })
                }}>
                    <h5>{"If you use a screen reader".translate(this.props.lang)}</h5>
                    <div style={{ transform: `rotate(90deg)`, fontSize: 24 }}>{">"}</div>
                </div>
                {
                    this.state.showReaderDropDown ?
                        <div style={{ textAlign: 'left' }}>
                            <p style={{ padding: 10 }}>
                                {"The most common issue is that the entire QR code doesn't fit on the screen. Please try to:".translate(this.props.lang)}

                            </p>
                            <ul>
                                <li>{'Ensure that the screen is switched on and Screen Curtain or similar functions are switched off.'.translate(this.props.lang)}</li>
                                <li>{'Zoom out in your browser by pressing Ctrl/Cmd+0.'.translate(this.props.lang)}</li>
                                <li>{'Zoom out with magnification tools such as ZoomText.'.translate(this.props.lang)}</li>
                                <li>{'Ensure the browser window is maximized by:'.translate(this.props.lang)}</li>
                                <li>{'Clicking the QR code above'.translate(this.props.lang)}</li>
                                <li>{'Using the short commands:'.translate(this.props.lang)}</li>
                                <li>{'Windows: Ctrl+Arrow up'.translate(this.props.lang)}</li>
                                <li>{'Mac: Ctrl+F'.translate(this.props.lang)}</li>
                                <li>{'Hold your phone in portrait mode 40cm from the screen when you scan the QR code.'.translate(this.props.lang)}</li>
                            </ul>
                        </div>
                        :
                        null
                }
            </div>
            <hr />
        </div>
    }


    render() {

        const { state } = this;
        const { hasBankId, hasNetId, hasMitId, country, skipBankId, skipNetId, skipMitId } = this.props;
        function renderButtonTextAndAction() {
            let obj = {
                title: 'Create Referral',
                tooltip: 'You can create a new case here',

                button: 'Next',
                action: 'next-step',
                disabled: false
            };

            switch (state.step) {
                case 1: { // Patient info
                    obj.title = 'Patient Information';
                    obj.tooltip = ['denmark', 'sweden'].includes(country) ? 'Add patient information here. If a patient with entered SSN does not exist in our system, you will be prompted to enter other needed information' : 'Add patient information here. Make sure that you have patient consent to share their information';

                    if (['denmark', 'sweden'].includes(country)) {
                        if (!state.patient.ssn?.trim?.() || (country === 'denmark' ? state.patient.ssn?.length < 10 : state.patient.ssn?.length < 12)) {
                            obj.action = 'no-action';
                            obj.disabled = true;
                        }
                    } else {
                        if (state.patient.type !== 'external' || !state.patient.dateOfBirth) {
                            obj.action = 'no-action';
                            obj.disabled = true;
                        }
                    }

                    if (!state.patient || !state.patientConsent || !state.patient.type || (state.patient.type === 'internal' && !state.patient.id) || (state.patient.type === 'external' && (!state.patient.name?.trim?.() || !state.patient.phone?.trim?.()))) {
                        obj.action = 'no-action';
                        obj.disabled = true;
                    };

                    if (state.patient.type === 'external') {
                        const canHaveOtherGender = state?.clinicGroupSettings?.patientInfoSettings?.canHaveOtherGender === true;
                        if (state.patient.gender) {
                            if (canHaveOtherGender) {
                                if (state.patient.gender === 'other' || !state.patient.gender?.trim()) {
                                    obj.action = 'no-action';
                                    obj.disabled = true;
                                }
                            } else {
                                if (!['male', 'female'].includes(state.patient.gender)) {
                                    obj.action = 'no-action';
                                    obj.disabled = true;
                                }
                            }
                        }
                    }

                    break;
                };
                case 2: { // Sending clinic info (sender)
                    obj.title = 'Sending clinic';
                    obj.tooltip = 'Add information about your clinic here. Please enter either phone or email (or both). If your clinic is part of the Curoflow system and is connected to Curoflow e-Connect, please add this case in your dashboard, and not here!';

                    if (!state.sender || !state.sender.name?.trim?.() || !state.sender.city?.trim?.() || !state.sender.street?.trim?.() || !state.sender.zip?.trim?.() || !state.sender.user?.trim?.() || (!state.sender.phone?.trim?.() && !state.sender.email?.trim?.())) {
                        obj.action = 'no-action';
                        obj.disabled = true;
                    };

                    break;
                };
                case 3: { // Case details
                    obj.title = 'Choose form or upload documents';
                    obj.tooltip = 'Choose to either fill out a form or upload documents and send in.';

                    if (!state.submitEnabled && (!state.subject?.trim?.() || (!state.anamnesis?.trim?.() && !state.status?.trim?.()) && !state.attachments?.length)) {
                        obj.action = 'no-action';
                        obj.disabled = true;
                    } else {
                        // obj.action = 'check-ssn'
                        if ((['sweden'].includes(country) && ((hasBankId && !skipBankId) || (hasNetId && !skipNetId))) || ['denmark'].includes(country) && hasMitId && !skipMitId) obj.action = 'sign';
                        else {
                            obj.action = 'submit';
                            obj.button = 'Submit';
                        };
                    }

                    break;
                };

                case 4: { // signing with bank id
                    obj.title = hasBankId && !skipBankId && skipNetId ? 'Sign with BankID'
                        : hasNetId && !skipNetId && skipBankId ? 'Sign with SITHS'
                            : ['denmark'].includes(country) && hasMitId && !skipMitId ? 'Sign with MITID'
                                : 'Sign with BankID or SITHS';

                    obj.tooltip = hasBankId && !skipBankId && skipNetId ? 'In order to submit this case, you must confirm your identity first, and sign the submission of this case with your BankID'
                        : hasNetId && !skipNetId && skipBankId ? 'In order to submit this case, you must confirm your identity first, and sign the submission of this case with your SITHS card'
                            : ['denmark'].includes(country) && hasMitId && !skipMitId ? 'In order to submit this case, you must confirm your identity first, and sign the submission of this case with your MITID'
                                : 'In order to submit this case, you must confirm your identity first, and sign the submission of this case with your BankID or SITHS card';

                    obj.button = 'Sign and Submit';

                    if (state.submitting) {
                        obj.title = 'Submitting Case';
                        obj.tooltip = 'Case submittion is in progress. Please do not close this page until the submitting process is done';
                    }

                    if (!state.bankId?.trim?.() || (country === 'denmark' ? state.bankId?.length !== 10 : state.bankId?.length !== 12)) {
                        obj.action = 'no-action';
                        obj.disabled = true;
                    } else {
                        obj.action = 'sign';
                    };

                    break;
                };
            }

            return obj;
        }

        return (<>
            <Modal
                isOpen={this.props.isOpen}
                size='md'
                centered
            >
                <ModalHeader>
                    {this.state.step === 5 && !this.state.sign && !this.state.submitting && !this.state.error ? 'Referral submitted'.translate(this.props.lang) : renderButtonTextAndAction()?.title?.translate(this.props.lang)}
                    {this.state.step === 5 && !this.state.sign && !this.state.submitting && !this.state.error ? null : <InfoWithTooltip style={{ bottom: 4 }} lang={this.props.lang} text={renderButtonTextAndAction()?.tooltip || ''} />}
                </ModalHeader>

                <ModalBody>
                    {this.state.error ? <div style={{ padding: 10 }} key='paosdufpoasduf'>
                        <p style={{ color: 'red', textAlign: 'center', fontSize: 16 }}>{this.state.error?.translate?.(this.props.lang)}</p>
                    </div> : this.state.submitting ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10 }}>
                        <Player
                            autoplay={true}
                            loop={true}
                            src="/lf30_editor_l5cxzdyf.json"
                            style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                        />
                    </div> : this.state.step === 1 ? <Fragment key='e-connect-modal-patient'>
                        {['denmark', 'sweden'].includes(this.props.country) ? <SSNField
                            clinicAlias={this.props.alias}
                            clinicGroupId={this.props.clinicGroupId}
                            country={this.props.country}
                            value={this.state.patient.ssn || ''}
                            label={'Social security number'.translate(this.props.lang)}
                            error={this.state.ssnError}
                            haveValidation={true}
                            onChange={value => {
                                let country = this.state.countryStateDict?.['ssn'] ?? this.props.country;
                                if ((country === 'denmark' && value?.length > 10) || value?.length > 12) return;
                                if ((country === 'denmark' && value?.length === 10) || value?.length === 12) this.checkSSN(value);
                                else this.setState(prev => ({ ...prev, ssnError: null, patient: { ...prev?.patient, ssn: value, type: null, id: null } }))
                            }}
                            getCountryState={(countryState) => {
                                let countryStateDict = this.state.countryStateDict ?? {};
                                countryStateDict['ssn'] = countryState;
                                this.setState({ countryStateDict })
                            }}
                        /> : null}
                        {this.state.patient?.type === 'external' ? <Fragment key='e-connect-modal-patinet-data'>
                            <FormGroup>
                                <Label htmlFor='patient-name' className='col-form-label-sm'>{'First and last name'.translate(this.props.lang)}:*</Label>
                                <Input type='text' id='patient-name' required value={this.state.patient.name || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, patient: { ...prev?.patient, name: value } })) }} name='patient-name' />
                            </FormGroup>
                            {!['denmark', 'sweden'].includes(this.props.country) ? <FormGroup>
                                <DateOfBirth
                                    label={'Date of birth'.translate(this.props.lang)}
                                    value={this.state.patient.dateOfBirth}
                                    dateFormat={this.props.dateFormat}
                                    // enableManualInput={true}
                                    lang={this.props.lang}
                                    onChange={value => {
                                        // const value = e?.target?.value ?? '';
                                        this.setState(prev => ({ ...prev, patient: { ...(prev?.patient || {}), dateOfBirth: value } }));
                                    }}
                                />
                            </FormGroup> : null}
                            <FormGroup key='gender' tag='fieldset'>
                                <GenderV2Field
                                    value={this.state.patient.gender}
                                    onChange={(val) => {
                                        let patient = { ...(this.state.patient || {}), gender: val };
                                        this.setState({ patient });
                                    }}
                                    id='gender'
                                    name='gender'
                                    lang={this.props.lang}
                                    data={{
                                        externalState: {
                                            groupData: this.state.clinicGroupSettings,
                                        }
                                    }}
                                    labelInfo={"The patient's biological sex is needed for proper treatment".translate(this.props.lang)}
                                />
                            </FormGroup>
                            {/* <FormGroup>
                                <Label htmlFor='patient-gender' size='sm' className='form-group-label-wrap' style={{ position: 'relative' }}>
                                    {'Sex'.translate(this.props.lang)}:*
                                    <div className='info' >
                                        <InlineSVG src={infoIcon} />
                                        <div className="info-text">{"The patient's biological sex is needed for proper treatment".translate(this.props.lang)}</div>
                                    </div>
                                </Label>
                                <Input id='patient-gender' autoComplete='sex' name='patient-gender' value={this.state.patient.gender} type='select' onChange={e => {
                                    let value = e?.target?.value; this.setState(prev => ({
                                        ...prev,
                                        patient: {
                                            ...prev.patient,
                                            gender: value
                                        }
                                    }))
                                }} >
                                    <option key={'e'} value=''>{''}</option>
                                    <option key={'m'} value='male'>{'Male'.translate(this.props.lang)}</option>
                                    <option key={'f'} value='female'>{'Female'.translate(this.props.lang)}</option>
                                </Input>
                            </FormGroup> */}
                            <PhoneField
                                countryTwoLetter={this.props.countryTwoLetter}
                                country={this.props.country}
                                label={'Phone number'.translate(this.props.lang) + ':'}
                                value={this.state.patient.phone}
                                haveValidation={true}
                                onChange={e => {
                                    let value = e?.replace(/ /g, '')?.replace('+', '');
                                    this.setState(prev => ({
                                        ...prev,
                                        patient: {
                                            ...prev?.patient,
                                            phone: value
                                        }
                                    }))
                                }}
                            />
                            <FormGroup>
                                <Label htmlFor='patient-email' className='col-form-label-sm'>{'Email address'.translate(this.props.lang)}:</Label>
                                <Input type='email' id='patient-email' name='patient-email' value={this.state.patient.email} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, patient: { ...prev?.patient, email: value } })) }} />
                            </FormGroup>
                        </Fragment> : null}
                        <Checkbox small={true} checked={this.state.patientConsent} onChange={e => {
                            const patientConsent = e?.target?.checked;
                            this.setState({ patientConsent });
                        }
                        } label={'Patient has given consent to be referred and their information to be shared'.translate(this.props.lang)} />
                    </Fragment> : this.state.step === 2 ? <Fragment key='e-connect-modal-sender'>
                        <FormGroup>
                            <Label htmlFor='name' className='col-form-label-sm'>{'Your name and title'.translate(this.props.lang)}:*</Label>
                            <Input type='text' id='name' autoComplete='name' name='name' required value={this.state.sender.user || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, sender: { ...prev?.sender, user: value } })) }} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor='clinic-name' className='col-form-label-sm'>{'Clinic name'.translate(this.props.lang)}:*</Label>
                            <Input type='text' id='clinic-name' name='clinic-name' required value={this.state.sender.name || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, sender: { ...prev?.sender, name: value } })) }} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor='city' className='col-form-label-sm'>{'City'.translate(this.props.lang)}:*</Label>
                            <Input type='text' id='city' autoComplete='address-level2' name='city' required value={this.state.sender.city || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, sender: { ...prev?.sender, city: value } })) }} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor='zip' className='col-form-label-sm'>{'Zip'.translate(this.props.lang)}:*</Label>
                            <Input type='text' id='zip' autoComplete='postal-code' name='zip' required value={this.state.sender.zip || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, sender: { ...prev?.sender, zip: value } })) }} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor='street' className='col-form-label-sm'>{'Street'.translate(this.props.lang)}:*</Label>
                            <Input type='text' id='street' autoComplete='street-address' name='street' required value={this.state.sender.street || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, sender: { ...prev?.sender, street: value } })) }} />
                        </FormGroup>
                        <PhoneField
                            countryTwoLetter={this.props.countryTwoLetter}
                            country={this.props.country}
                            label={'Phone number'.translate(this.props.lang) + ':'}
                            value={this.state.sender.phone}
                            haveValidation={true}
                            onChange={e => {
                                let value = e?.replace(/ /g, '')?.replace('+', '');
                                this.setState(prev => ({
                                    ...prev,
                                    sender: {
                                        ...prev?.sender,
                                        phone: value
                                    }
                                }))
                            }}
                        />
                        <FormGroup>
                            <Label htmlFor='email' className='col-form-label-sm'>{'Email address'.translate(this.props.lang)}:</Label>
                            <Input type='email' id='email' autoComplete='email' name='email' value={this.state.sender.email || ''} onChange={e => { let value = e?.target?.value; this.setState(prev => ({ ...prev, sender: { ...prev?.sender, email: value } })) }} />
                        </FormGroup>
                    </Fragment>
                        : this.state.step === 3 ?
                            <Fragment key='e-connect-modal-data'>

                                {
                                    this.state.attachments?.length && !this.state.selectedReferral && !this.state.questionaryAnswers ?
                                        <>
                                            <FormGroup>
                                                <Label htmlFor='subject' className='col-form-label-sm'>{'Subject'.translate(this.props.lang)}:*</Label>
                                                <Input type='textarea' id='subject' name='subject' rows='2' placeholder={'What is this case in regard to?'.translate(this.props.lang)} required value={this.state.subject || ''} onChange={e => { let value = e?.target?.value; this.setState({ subject: value }) }} />
                                            </FormGroup>
                                            {/* <FormGroup>
                                                <Label htmlFor='anamnesis' className='col-form-label-sm'>{'Anamnesis'.translate(this.props.lang)}:</Label>
                                                <Input type='textarea' id='anamnesis' name='anamnesis' rows='5' required value={this.state.anamnesis || ''} onChange={e => { let value = e?.target?.value; this.setState({ anamnesis: value }) }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label htmlFor='status' className='col-form-label-sm'>{'Status'.translate(this.props.lang)}:</Label>
                                                <Input type='textarea' id='status' name='status' rows='5' required value={this.state.status || ''} onChange={e => { let value = e?.target?.value; this.setState({ status: value }) }} />
                                            </FormGroup> */}
                                        </>
                                        :
                                        null
                                }
                                {
                                    !this.state.attachments?.length && !this.state.submitEnabled ?
                                        <h6 className='e-connect-title ext-ec-attch-title' style={{ paddingTop: 20 }}>
                                            {'Select form'.translate(this.props.lang)}:
                                        </h6>
                                        :
                                        null
                                }
                                {
                                    !this.state.attachments?.length && !this.state.submitEnabled ?
                                        <CustomSelectWithSearch
                                            isInputClearable={true}
                                            lang={this.props.lang}
                                            items={this.state.referrals?.filter(item => !item.nonVisible).map((item, idx) => {
                                                return {
                                                    name: item.name,
                                                    value: item._id
                                                }
                                            })}
                                            value={this.state.selectedReferral}
                                            // hideSearchField={this.state.clinicGroup?.hideFormSearchFild}
                                            maxHeight={'50vh'}
                                            onChange={(e) => {
                                                if (e.value && this.state.selectedReferral && this.state.selectedReferral === e.value) {
                                                    this.setState({
                                                        selectedReferral: null
                                                    })
                                                    return;
                                                }
                                                if (e && e.value && this.state.referrals.filter(item => item._id === e.value).length) {
                                                    this.setState({ selectedReferral: e.value }, () => {
                                                        let referral = null;
                                                        for (let i = 0; i < this.state.referrals.length; i++) {
                                                            if (this.state.referrals[i]._id == e.value) {
                                                                referral = this.state.referrals[i];
                                                                break;
                                                            }
                                                        }
                                                        this.setState({
                                                            selectedReferral: e.value,
                                                            referral,
                                                        });
                                                    })
                                                } else {
                                                    this.setState({ selectedReferral: null })
                                                }


                                            }}
                                        />
                                        :
                                        null
                                }

                                {/* {
                                    this.state.submitEnabled ?
                                        <FormGroup className='e-connect-preview-btn'>
                                            <Label htmlFor='preview-answers' className='col-form-label-sm'>{"Finished -".translate(this.props.lang) + ' ' + `${this.state.referral.name}`}</Label>
                                            <Button color='primary' onClick={() => {
                                                this.setState({
                                                    previewAnswers: true
                                                })
                                            }}>{'Preview answers'.translate(this.props.lang)}</Button>
                                        </FormGroup>
                                        :
                                        null
                                } */}


                                <Row>
                                    {
                                        !this.state.selectedReferral && !this.state.submitEnabled && this.state.attachments?.length ?
                                            <Col style={{ paddingTop: 20 }}>
                                                <h6 className='e-connect-title ext-ec-attch-title'>
                                                    {'Do you only want to upload documents?'.translate(this.props.lang)}:
                                                    {' '}
                                                    <InfoWithTooltip style={{}} text={`You can upload as many files and/or images as you need. Just click on the upload button, or drag and drop your files. Allowed file types are: ${allowedFileTypeExtensions.map(s => `.${s}`).join(', ')}`} lang={this.props.lang} />
                                                </h6>
                                                <div className='e-connect-modal-attachments'>
                                                    <div
                                                        onDragEnter={e => { e.preventDefault(); e.stopPropagation(); this.setState({ _dragging: true }) }}
                                                        onDragOver={e => { e.preventDefault(); e.stopPropagation(); }}
                                                        onDragLeave={e => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            this.setState({ _dragging: false })
                                                        }}
                                                        onDrop={e => {
                                                            e.preventDefault();
                                                            const files = e?.dataTransfer?.files;
                                                            if (files) this.uploadFiles(files);
                                                        }}
                                                        className={`${this.state._uploading || this.state._dragging ? 'ec-uploading-pl' : ''}`}
                                                    >
                                                        {this.state._uploading || this.state._dragging ? <div key='_uploading'>
                                                            {this.state._uploading ? 'Uploading...'.translate(this.props.lang) : this.state._dragging ? 'Drop files here'.translate(this.props.lang) : ''}
                                                        </div>
                                                            :
                                                            this.state.attachments?.map?.((item, i) => {
                                                                if (!item?.url) return null;
                                                                return <div
                                                                    key={item?.url ? item.url : item?.name ? `${item.name}-${i}` : i}
                                                                    className='econnect-attachment-item'
                                                                >
                                                                    <div>
                                                                        <button
                                                                            type='button'
                                                                            title={'Opens in new browser tab'.translate(this.props.lang)}
                                                                            onClick={() => {
                                                                                if (typeof window !== 'undefined') window.open(API_ENDPOINT + item.url, '_blank')
                                                                            }}
                                                                        >
                                                                            &#91;
                                                                            {'Open'.translate(this.props.lang)}
                                                                            &#93;
                                                                        </button>
                                                                        <div>{item?.name}</div>
                                                                    </div>
                                                                    <button type='button' onClick={() => {
                                                                        const url = item.url;
                                                                        const attachments = this.state.attachments?.filter?.(item => item.url !== url);
                                                                        this.setState({ attachments })
                                                                    }}>
                                                                        <InlineSVG src={trashIcon} title={'Delete'.translate(this.props.lang)} />
                                                                    </button>
                                                                </div>
                                                            })}
                                                    </div>
                                                    <div className={`${this.state._uploading ? 'ec2-disabled-indom' : ''}`}>
                                                        <Label className='ext-ec-upload-btn' title={'Upload'.translate(this.props.lang)}>
                                                            <InlineSVG src={uploadIcon} />
                                                            <Input disabled={this.state._uploading} multiple accept={`.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.txt,.xls,.xlsx,.mp4,.ppt,.pptx,.json,.csv,${allowedFileTypes.join(',')}`} type='file' onChange={(e) => {
                                                                const files = e?.target?.files;
                                                                if (files) this.uploadFiles(files);
                                                            }} />
                                                        </Label>
                                                    </div>
                                                </div>
                                            </Col>
                                            :
                                            !this.state.selectedReferral && !this.state.submitEnabled ?
                                                <Col>
                                                    <h6 className='e-connect-title ext-ec-attch-title'>
                                                        {'Do you only want to upload documents?'.translate(this.props.lang)}:
                                                    </h6>
                                                    <div className='e-connect-modal-attachments' style={{ overflow: 'unset', border: 'none', backgroundColor: 'transparent' }}>

                                                        <div className={`${this.state._uploading ? 'ec2-disabled-indom' : ''}`} style={{ overflow: 'unset', border: 'none', backgroundColor: 'transparent' }}>
                                                            <Label className='ext-ec-upload-btn' title={'Upload'.translate(this.props.lang)}>
                                                                <div>{'Upload document'.translate(this.props.lang)}</div>
                                                                <Input disabled={this.state._uploading} multiple accept={`.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.txt,.xls,.xlsx,.mp4,.ppt,.pptx,.json,.csv,${allowedFileTypes.join(',')}`} type='file' onChange={(e) => {
                                                                    const files = e?.target?.files;
                                                                    if (files) this.uploadFiles(files);
                                                                }} />

                                                            </Label>
                                                            <InfoWithTooltip style={{}} text={`You can upload as many files and/or images as you need. Just click on the upload button, or drag and drop your files. Allowed file types are: ${allowedFileTypeExtensions.map(s => `.${s}`).join(', ')}`} lang={this.props.lang} />

                                                        </div>
                                                    </div>
                                                </Col>
                                                :
                                                null
                                    }

                                </Row>
                            </Fragment>
                            :
                            this.state.step === 4 ?
                                <Fragment key='e-connect-modal-sign'>
                                    {
                                        this.state.sign && ((hasBankId && !skipBankId && skipNetId && skipMitId) || this.state.pickedLoginMethod === 'bankid') ?
                                            <Fragment key='e-connect-modal-sign-1'>
                                                {
                                                    hasBankId && ((hasNetId && !skipNetId) || (hasMitId && !skipMitId)) && !skipBankId ?
                                                        <button onClick={() => {
                                                            this.setState({
                                                                redirect_url: false,
                                                                qrCodeLink: false,
                                                                key: false,
                                                                openSiths: false,
                                                                pickedLoginMethod: false
                                                            })
                                                        }} className="login-back-e-connect"> <Isvg src={ArrowBack} /> {'go back'.translate(this.props.lang)}</button>
                                                        :
                                                        null
                                                }

                                                {/* <div className='bank-id-checkout'>
                                                    <div  >


                                                        <img id='qr-image' src={this.state.qrCodeLink} style={{ height: 'auto', maxWidth: 200, width: 200 }} />

                                                    </div>
                                                    <p>{"Scan QR code if bankid app doesn't shows up".translate(this.props.lang)}</p>
                                                    <a href={this.state.redirect_url} className='btn btn-primary'>{"Open BankID on this device".translate(this.props.lang)}</a>
                                                </div> */}
                                                <div className="bank-id-sign" ref={(node) => { this.wrapRef = node }}>


                                                    {this.state.loading && (!this.state.qrCodeLink || this.state.qrCodePendingSign) && !this.state.qrCodeExpired ?

                                                        <div>
                                                            <Player
                                                                autoplay={true}
                                                                loop={true}
                                                                renderer={'svg'}
                                                                src="/lf30_editor_l5cxzdyf.json"
                                                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "64px" : "128px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "64px" : "128px" }}
                                                            ></Player>

                                                            {
                                                                this.state.qrCodePendingSign ?
                                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <p>{"Enter your security code in the BankID app and select Identify.".translate(this.props.lang)}</p>

                                                                        {
                                                                            this.generateDropDownText()
                                                                        }
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                        :
                                                        null
                                                    }

                                                    {
                                                        document.fullscreenElement && !this.state.exitFullscreen && !this.state.qrCodeExpired && !this.state.qrCodePendingSign ?
                                                            <Button className='exit-button-full-screen' onClick={() => {
                                                                document.exitFullscreen();
                                                            }}>
                                                                <div>
                                                                    {'Exit full screen'.translate(this.props.lang)}
                                                                </div>
                                                                <div style={{ height: 30, width: 30, borderRadius: '50%', color: 'white', background: '#568AC8', display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: 20 }}>X</div>
                                                            </Button>
                                                            :
                                                            null
                                                    }


                                                    {this.state.qrCodeLink && !this.state.qrCodeExpired && !this.state.qrCodePendingSign ?

                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                                            <p id="above-qr-image-p">
                                                                {"Please start the BankID app and scan the QR code".translate(this.props.lang)}
                                                            </p>
                                                            <div id={'qr-image-div'} ref={(node) => this.qrImage = node} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <button ref={(node) => this.qrCodeButton = node} onClick={() => {
                                                                    const el = this.wrapRef;
                                                                    if (!el) return;


                                                                    if (!document.fullscreenElement) {
                                                                        try {
                                                                            if (el.requestFullscreen) {
                                                                                el.requestFullscreen();
                                                                            }
                                                                            if (el.webkitRequestFullscreen) { /* Safari */
                                                                                el.webkitRequestFullscreen();
                                                                            }
                                                                            this.setState({
                                                                                exitFullscreen: false
                                                                            })
                                                                        } catch (e) {
                                                                            console.error(e)
                                                                        }
                                                                    } else {
                                                                        document.exitFullscreen();
                                                                        this.setState({
                                                                            exitFullscreen: true
                                                                        })
                                                                    }
                                                                }} aria-label='QR code, scan with BankID app, hold your phone in portrait mode 40cm from the screen. Click to enter full screen' >
                                                                    <img id='qr-image' onLoad={() => {
                                                                        this.setState({
                                                                            imageLoaded: true
                                                                        })
                                                                    }} alt='QR code. Click for fullscreen' src={this.state.qrCodeLink} style={{ height: 'auto', maxWidth: 185, width: 185 }} />

                                                                </button>

                                                                {
                                                                    this.state.qrCodeTimeExpiration ?
                                                                        <div style={{ marginBottom: 5 }}>
                                                                            <div style={{ position: 'relative', width: 150, height: 12, overflow: 'hidden', alignItems: 'center', marginBottom: 10 }}>
                                                                                <div style={{ height: '100%', background: 'rgb(24 62 79 / var(--tw-bg-opacity, 1))', transition: 'width .35s ease', width: `${this.percentageLeft(this.state.qrCodeTimeExpiration, 150)}%` }} />
                                                                            </div>
                                                                            <div aria-live style={{ display: 'flex', background: 'white', alignItems: 'center', justifyContent: 'center', font: '12px', color: 'black' }}>{this.minutesLeft(this.state.qrCodeTimeExpiration)}</div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    this.state.qrCodeTimeExpiration && (300 - 2 * this.state.qrCodeTimeExpiration) <= 30 ?
                                                                        <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                                                            this.setState({
                                                                                qrCodeExpired: false,
                                                                                qrCodePendingSign: false,
                                                                                qrCodeTimeExpiration: 1,
                                                                            }, () => {
                                                                                this.startBankIDSign()
                                                                            })

                                                                        }}>{'Extend time'.translate(this.props.lang)}</Button>
                                                                        :
                                                                        null
                                                                }

                                                            </div>
                                                            <a href={this.props.redirectUrl} style={{ marginBottom: 20 }} className='btn btn-primary'>{"Open BankID on this device".translate(this.props.lang)}</a>

                                                            {
                                                                this.generateDropDownText()
                                                            }


                                                        </div>
                                                        :
                                                        this.state.qrCodeExpired ?
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                <p style={{ color: 'red' }}>{'Due to inactivity, the session has expired'.translate(this.props.lang)}</p>
                                                                <Button style={{ backgroundColor: '#568AC8', marginBottom: 20 }} onClick={() => {
                                                                    this.setState({
                                                                        qrCodeExpired: false,
                                                                        qrCodePendingSign: false,
                                                                        qrCodeTryAgain: true,
                                                                        qrCodeTimeExpiration: 1,
                                                                    }, () => {
                                                                        this.startBankIDSign()
                                                                    })
                                                                }}>{'Try again'.translate(this.props.lang)}</Button>

                                                            </div>
                                                            :
                                                            null
                                                    }

                                                </div>

                                            </Fragment>
                                            : this.state.sign && ((hasNetId && !skipNetId && skipBankId && skipMitId) || this.state.pickedLoginMethod === 'netid') ?
                                                <Fragment key='e-connect-modal-sign-1'>
                                                    {
                                                        hasBankId && hasNetId && !skipBankId && !skipNetId ?
                                                            <button onClick={() => {
                                                                this.setState({
                                                                    redirect_url: false,
                                                                    qrCodeLink: false,
                                                                    key: false,
                                                                    openSiths: false,
                                                                    pickedLoginMethod: false
                                                                })
                                                            }} className="login-back-e-connect"> <Isvg src={ArrowBack} /> {'go back'.translate(this.props.lang)}</button>
                                                            :
                                                            null
                                                    }

                                                    <div className='bank-id-checkout'>
                                                        <div>

                                                            <iframe ref={(node) => this.bankIdIframe = node} onLoad={() => {
                                                                try {
                                                                    if (this.bankIdIframe && this.bankIdIframe.contentWindow && this.bankIdIframe.contentWindow.location && this.bankIdIframe.contentWindow.location.href && this.bankIdIframe.contentWindow.location.href.indexOf('ui/bankidse') !== -1) {
                                                                        this.setState({
                                                                            _hideIframe: true
                                                                        })
                                                                    }
                                                                } catch (e) { }
                                                            }} src={this.state.openSiths} style={this.state._hideIframe ? { opacity: 0 } : { width: '100%', height: 770, border: 'none' }} />
                                                        </div>
                                                    </div>
                                                </Fragment>
                                                : this.state.sign && ((hasMitId && !skipMitId && skipBankId && skipNetId) || this.state.pickedLoginMethod === 'mitid') ?
                                                    <Fragment key='e-connect-modal-sign-1'>

                                                        <button onClick={() => {
                                                            this.setState({
                                                                mitIDRedirectUrl: false,
                                                                mitIDKey: false,
                                                                pickedLoginMethod: false
                                                            })
                                                        }} className="login-back-e-connect"> <Isvg src={ArrowBack} /> {'go back'.translate(this.props.lang)}</button>
                                                        <div className='bank-id-checkout'>
                                                            <div>
                                                                <iframe ref={(node) => this.mitIdFrame = node} onLoad={() => {
                                                                    try {
                                                                        if (this.mitIdFrame && this.mitIdFrame.contentWindow && this.mitIdFrame.contentWindow.location && this.mitIdFrame.contentWindow.location.href && this.mitIdFrame.contentWindow.location.href.indexOf('sessionId') !== -1) {
                                                                            this.setState({
                                                                                mitidVerify: this.mitIdFrame.contentWindow.location.href,
                                                                                mitIDRedirectUrl: null
                                                                            })
                                                                        } else {
                                                                            this.setState({
                                                                                mitIDRedirectUrl: null,
                                                                            })
                                                                        }
                                                                    } catch (e) { }
                                                                }} src={this.state.mitIDRedirectUrl} style={{ width: '100%', height: 770, border: 'none' }} />
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                    :
                                                    this.state.sign ?
                                                        <div className='login-btns-e-connect'>
                                                            {
                                                                hasBankId && !skipBankId ?
                                                                    <button onClick={() => {
                                                                        this.setState({
                                                                            pickedLoginMethod: 'bankid'
                                                                        }, () => {
                                                                            this.handler('sign');
                                                                        })
                                                                    }}><img src={BankId} /> {'Sign with BankID'.translate(this.props.lang)}</button>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                hasNetId && !skipNetId ?
                                                                    <button onClick={() => {
                                                                        this.setState({
                                                                            pickedLoginMethod: 'netid'
                                                                        }, () => {
                                                                            this.handler('sign');
                                                                        })

                                                                    }}><img src={NetId} /> {'Sign with SITHS'.translate(this.props.lang)}</button>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                hasMitId && !skipMitId ?
                                                                    <button onClick={() => {
                                                                        this.setState({
                                                                            pickedLoginMethod: 'mitid'
                                                                        }, () => {
                                                                            this.handler('sign');
                                                                        })
                                                                    }}><img src={MitID} /> {'Sign with MitID'.translate(this.props.lang)}</button>
                                                                    :
                                                                    null
                                                            }

                                                        </div>

                                                        :
                                                        // <Fragment key='e-connect-modal-sign-2'>
                                                        //     <div className='bank-id-checkout'>
                                                        //         <h3 >{'Sign with BankID'.translate(this.props.lang)}</h3>
                                                        //         <div className='bank-id'>
                                                        //             <img src={bankIdIcon} />
                                                        //             <Input value={this.state.bankId} onChange={(e) => {
                                                        //                 const value = e?.target?.value;
                                                        //                  ADD COUNTRY IF THIS PART IS EVER UNCOMMENTED!
                                                        //                 if (value.length > 12 || (value !== '' && !isStringAValidNumber(value))) return;
                                                        //                 if (value.length === 12) {
                                                        //                     const check = validateSocialSecurityNumber(value, null, this.props.country);
                                                        //                     if (check?.error || !isStringAValidNumber(value)) return this.setState({
                                                        //                         bankId: value,
                                                        //                         bankIdError: true
                                                        //                     });

                                                        //                     this.setState({ bankId: value, bankIdError: null })
                                                        //                 } else this.setState({ bankId: value, bankIdError: null })
                                                        //             }} placeholder="ÅÅÅÅMMDDNNNN" type='text' />
                                                        //         </div>

                                                        this.state.bankIdError ?
                                                            <p style={{ color: 'red', fontSize: 16, textAlign: 'center' }}>{'BankID sign failed!'.translate(this.props.lang)}</p>
                                                            :
                                                            null

                                        //     </null>
                                        // </Fragment>
                                    }
                                </Fragment>
                                :
                                <Fragment key='e-connect-modal-finish'>
                                    <div style={{ padding: 10 }}>
                                        <p style={{ textAlign: 'center', fontSize: 16 }}>
                                            {'Your case has been successfully submitted. The receiving clinic will now handle this case.'.translate?.(this.props.lang)}
                                        </p>
                                    </div>
                                </Fragment>}

                    {this.state.loading && !this.state.submitting && !this.state.sign ? <div className='econnect-loader'><Player
                        autoplay={true}
                        loop={true}
                        src="/lf30_editor_l5cxzdyf.json"
                        style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                    /></div> : null}
                </ModalBody>

                <ModalFooter style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <button style={{ display: 'none', visibility: 'hidden' }} aria-hidden></button>

                    {this.state.step === 5 && this.state.uuid && !this.state.sign && !this.state.submitting && !this.state.error && !this.state.pdfGenerated ? <Button
                        color='info'
                        disabled={this.state.loading}
                        onClick={() => {
                            this.getPdf(this.state.uuid);
                        }}
                    >
                        {'Save as PDF'.translate(this.props.lang)}
                    </Button> : null}

                    {[1, 2, 3, 4].includes(this.state.step) && !this.state.sign && !this.state.submitting && !this.state.error ? <Button
                        color='primary'
                        disabled={renderButtonTextAndAction()?.disabled}
                        onClick={() => this.handler(renderButtonTextAndAction()?.action)}
                    >
                        {renderButtonTextAndAction()?.button?.translate(this.props.lang)}
                    </Button> : null}

                    <Button
                        color='danger'
                        onClick={this.props.closeModal}
                        disabled={this.state.loading}
                    >
                        {'Close'.translate(this.props.lang)}
                    </Button>

                    <button style={{ display: 'none', visibility: 'hidden' }} aria-hidden></button>
                </ModalFooter>
            </Modal>

            {
                this.state.previewAnswers ?
                    <Modal isOpen={this.state.previewAnswers} centered>
                        <ModalHeader>{'Preview answers'.translate(this.props.lang)}</ModalHeader>
                        <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                            <PreviewAnsweredChatForm {...this.props}
                                // answer={(item) => {
                                //     this.setState({ questionaryAnswers: item })
                                // }}
                                referral={{
                                    name: this.state.referral.name,
                                    description: this.state.referral.description,
                                    intelligentReferral: this.state.referral?.intelligentReferral,
                                    items: this.state.referral.items
                                }}
                                eConnectForm={true}
                                // referralContentRef={this.state.referralContentRef}
                                alias={this.props.alias}
                                // disabledForm={typeof window != 'undefined' && localStorage?.getItem?.('profile') == 'doctor' && this.props.uData && this.props.uData?.userLevel == 20 ? true : false}
                                answers={this.state.questionaryAnswers}
                                // forPrint={this.state.activeReferralContent ? true : false}
                                sections={this.generateSections()}></PreviewAnsweredChatForm>


                        </ModalBody>
                        <ModalFooter>
                            <Button color='primary' onClick={() => {
                                this.setState({
                                    previewAnswers: false
                                })
                            }}>{'Close'.translate(this.props.lang)}</Button>
                        </ModalFooter>
                    </Modal>
                    :
                    null
            }

            {
                this.state.selectedReferral && this.state.referral ?
                    <Modal isOpen={this.state.selectedReferral && this.state.referral} centered>
                        <ModalHeader toggle={() => this.setState({
                            selectedReferral: null,
                            referral: null,
                            questionaryAnswers: null,
                            submitEnabled: false,
                        })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({
                            selectedReferral: null,
                            referral: null,
                            questionaryAnswers: null,
                            submitEnabled: false,
                        })}>&times;</button>}>{'Run questionary'.translate(this.props.lang)}</ModalHeader>

                        <ModalBody>


                            <ChatForms {...this.props}
                                referral={this.state.referral}
                                alias={this.props.alias}
                                answer={(item, isEnd) => {
                                    this.setState({ questionaryAnswers: item, submitEnabled: isEnd }, () => {
                                        this.generateHtmlPreview()

                                        if (isEnd) {
                                            this.generatePdf(this.state.selectedReferral, () => {

                                                if (skipBankId && skipMitId && skipNetId) {
                                                    this.handler('submit')
                                                } else {
                                                    this.handler('sign')
                                                }
                                                this.setState({
                                                    selectedReferral: null,
                                                })
                                            })

                                        }
                                    })
                                }}
                                // referralContentRef={this.state.referralContentRef}
                                eConnectForm={true}
                                clinicGroupId={this.props.clinicGroupId}
                                onChangeAttachment={(file) => this.onChangeAttachment(file)}
                                // disabledForm={false}
                                answers={this.state.questionaryAnswers}
                                // forPrint={false}
                                sections={this.generateSections()}></ChatForms>
                        </ModalBody>
                        <ModalFooter>
                            {
                                // this.state.submitEnabled ?
                                //     <Button color="primary" className='green-button' onClick={() => {
                                //         this.setState({
                                //             selectedReferral: null,
                                //         })
                                //     }}> {'Send'.translate(this.props.lang)} </Button>
                                //     :
                                //     null
                            }
                        </ModalFooter>
                    </Modal>
                    :
                    null
            }

        </>
        )
    }
}

export default EconnectExternalCasesModal